const statusTone: Record<string, string> = {
  已澄清: "bg-primary-100 text-primary-800 border-primary-200",
  反转中: "bg-accent-100 text-accent-900 border-accent-300",
  持续发酵: "bg-secondary-100 text-secondary-900 border-secondary-200",
  A: "bg-primary-100 text-primary-800 border-primary-200",
  B: "bg-secondary-100 text-secondary-900 border-secondary-200",
  C: "bg-accent-100 text-accent-900 border-accent-300",
};

export default function StatusBadge({ label, tone }: { label: string; tone?: string }) {
  const cls = statusTone[tone ?? label] ?? "bg-background-100 text-foreground-700 border-background-300";
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] font-medium ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {label}
    </span>
  );
}